<template>
<div id="info-popup">
  <div class="row">
    <div class="col-12 paragraph14 title">{{$t('app.statements.created_at')}} {{data.created_at | moment("YYYY-MM-DD") }}</div>
    <div class="col-12 paragraph14 title">{{$t('app.statements.updated_at')}}{{data.updated_at | moment("YYYY-MM-DD") }}</div>
  </div>
</div>
</template>

<script>
export default {
  name: 'InfoPopUp',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
#info-popup {
  .title {
    color: var(--main-color);
    padding-bottom: 4px;
    font-weight: 500;
    line-height: 1.21;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/base_states/InfoPopUp.vue